<script>
import UsersApi from "@/services/users-api";
import OrdersApi from "@/services/orders-api";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}

export default {
      components: {},

    props: {
    customerId:{
          type:(Number),
          default:0
      },
},

  data() {
    return {
        usersFilter:null,
        usersList: [],
        customersList:[],
        customersFilter:null,
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        customersListFields: 
            [
                
                { key:"companyName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                { key:"extId", label: "Code",   sortable: false, tdClass:"font-weight-bold ",},

                { key:"category", label: "Type",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },

                { key:"country", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"city", label: "",   thClass:"text-left d-md-table-cell d-none", tdClass:"text-left d-md-table-cell d-none"},
                // { key:"phone", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"address", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"users", label: "",thClass:"text-center", tdClass:"text-center"},
                { key:"status", label: "",thClass:"text-center", tdClass:"text-center"},
                

                { key:"actions", label:""}
            ],
        type:null,
        isCustomersTableBusy:false,
        showDetailsModal:false,
        showConditionsModal:false,
        citiesList:[],
        countriesList:[],
        selectedCountry:null,
        selectedCity:null,
        if_form_error:false,
        showForm:false,
        permissionGroupes:[
            { id: 8, label: "Administrateur Client",isSelected: 0 ,permission:"CUST_ADMIN" ,IsVisible: true},
            { id: 3, label: "Liste des Commandes",isSelected: 0 ,permission:"ORDER_LIST"},
            { id: 0, label: "Liste des Factures" ,isSelected: 0 , permission: "INVOICE" },
            { id: 5, label: "Liste des Bons de Livraisons",isSelected: 0 ,permission:"BON_LIV"},
            { id: 1, label: "Liste des Avoirs" ,isSelected: 0 ,permission: "AVOIR"},
            { id: 6, label: "Ajout des nouvelles Commandes" ,isSelected: 0 ,permission:"ADD_ORDER"},
            { id: 4, label: "Accès aux Reporting",isSelected: 0 ,permission:"REPORTING"},
            { id: 2, label: "Mails de notifications commandes" ,isSelected: 0 , permission:"EMAIL_STATES_ORDER", IsVisible: true },
            { id: 7, label: "Utiliser Login pour les notifs e-mails" ,isSelected: 0 ,permission:"EMAIL_RECEIVE_ON_OWN_MAIL_ADDRESS"},
            { id: 9, label: "Accés FTP en lecture (FTP_READ)" ,isSelected: 0 ,permission:"FTP_READ", supplierOnly: true},
            { id: 10, label: "Accés FTP en écriture (FTP_WRITE)" ,isSelected: 0 ,permission:"FTP_WRITE", supplierOnly: true}
        ],
     
        selectedUser:{
            id:'',name:'',userName:'',password:'',
            supplierId:null,status:1, 
            extSystemId:'', 
            codeCustomer:null,
            customerName:'',
            defaultAddressCode:null,
            permission:[],
        },
        showUsersModal:false,
        showPWModal:false ,
        isNew:false,
        selectedUserList:[],
        optionsDeliveryAddresses:[],
        selectedAddress:null,
        isPasswordChange:false,
        newPassword:null,
        selected:{country:"",city:""},    
        passwordHidden:true,
        showTraderModal:false,
        tradersList:[],

    
        selectedTrader:null,
        selectedPDF:null,
        gotTradersList:false,
        companyName:'',

        showTokenModal:false,
        generatedToken:null,
        isCopied: false,
      }
      
    },

    
    computed: {
        isGenerateApiKeyEnabled(){
          return  process.env.VUE_APP_FEATURE_GENERATE_API_KEY === 'true'
        },
        // FTP privileges can only be granted by the supplier, not by the customer admin
        isSupplier() {
          return this.$cookies.get("userr") == 1;
        },
        isFtpPermissionVisible() {
          return this.isSupplier && process.env.VUE_APP_FEATURE_FTP_IMPORTED_ORDERS === 'true';
        },
        ftpPermissionGroupes() {
            return this.permissionGroupes.filter(element => element.supplierOnly);
        },
        orderStatePermission() {
          return this.getPermission("EMAIL_STATES_ORDER");
        },
        adminPermission() {
          return this.getPermission("CUST_ADMIN");
        },
        adminPermissionGroupes() {
            return this.permissionGroupes.filter(element =>  !element.IsVisible && !element.supplierOnly);
        },
        envSupplierFullName(){
            return process.env.VUE_APP_CLIENT_FULL_NAME
        },
        isMultiAddressSuported(){
          return  process.env.VUE_APP_FEATURE_MULTI_ADDRESS_SUPPORTED === 'true'
        },

        isLoginSuggestionSupported(){
          return  process.env.VUE_APP_FEATURE_LOGIN_SUGGESTION === 'true'
        },

    },

  mounted() {
    this.getUserInfo()
    this.companyName = getCookie('companyName') 
  }, 
    
  methods: {

    generateToken() {
        try {
             UsersApi.generateToken(this.selectedUser.id).then(
                (result) => {
                    if (result && result.token) {
                        this.generatedToken = result.token;
                        this.showTokenModal = true;
                    }
                }) 
        } catch (error) {
            console.error("Error generating token:", error);
        }
    },

    openGenerateToken(user) {
        this.selectedUser = user;
        this.showTokenModal = true;
    },

    copyToken() {
        if (!this.generatedToken) return;
        navigator.clipboard.writeText(this.generatedToken).then(() => {
            this.isCopied = true;
            setTimeout(() => {
                this.isCopied = false;
            }, 2000);
        });
    },

    getCustomerPossibleDeliveryAddresses(customerId){
      OrdersApi.getCustomerDeliveryAddresses(customerId).then(
        (result)=>{
          if(result){
            this.optionsDeliveryAddresses=result
            if(this.optionsDeliveryAddresses.length){
              this.selectedAddress=this.optionsDeliveryAddresses[0]
            }
          }

        }
      )
    },

    setInfoCutommer(info){
        this.selectedUser.codeCustomer=info.codeCustomer
        this.selectedUser.customerName=info.customerName
    },

    setAllSelectedToZero() {
      if (this.permissionGroupes) {
        this.permissionGroupes.forEach(permission => {
            permission.isSelected = 0;
        });
      }
    },
    handler(permissions) {
        this.permissionGroupes.forEach(permission => {
            if (permissions.includes(permission.permission)) {
                permission.isSelected = 1;
            }

            else  {
                permission.isSelected = 0;
            }
        });
      },

    getUserInfo(){
        if (!this.customerId) {
        UsersApi.getUserInfo().then(
            result => {
                this.selectedUserList = result;
                this.setInfoCutommer(result[0])
            }
        );
    } else {
        UsersApi.getUserInfo(this.customerId).then(
            result => {
                this.selectedUserList = result;
                this.setInfoCutommer(result[0])
            }
        );
    }

    this.getCustomerPossibleDeliveryAddresses(this.customerId ? this.customerId : null)

},


    addNew(){
      this.setAllSelectedToZero()
      this.showUsersModal=true 
      this.showForm =true;
      this.cancelUserEdit();
      this.selectedUser.userName= this.isLoginSuggestionSupported ? '@ph'+this.selectedUser.codeCustomer+'.'+this.envSupplierFullName+'.com' : '';
      this.isNew=true
      this.isPasswordChange=false
} ,

    cancelUserEdit(){
      this.isNew=false
      this.selectedUser.id=null
      this.selectedUser.name=''
      this.selectedUser.userName=''
      this.selectedUser.password=''
      this.selectedUser.extSystemId=''
      this.selectedUser.permission=[];
      this.selectedAddress=null;
      
    },

    hideForm(){
      this.showForm =false;
      this.showUsersModal=false 
      this.isNew=false
    },

    editUser(user){
        this.showUsersModal=true 
        this.showForm =true;
        this.isPasswordChange=false
        this.cancelUserEdit();
        this.selectedUser.id=user.id
        this.selectedUser.name=user.name
        this.selectedUser.userName=user.userName
        this.selectedUser.status=user.status
        this.selectedUser.extSystemId=user.extSystemId
        this.selectedUser.codeCustomer=user.codeCustomer
        this.selectedAddress = this.optionsDeliveryAddresses.find(da => da.code == user.defaultAddressCode);
        this.handler(user.permission)

        
    },

    saveUser(){
        this.selectedUser.customerId= this.customerId
        this.selectedUser.permission= this.permissionGroupes
        .filter(permission => permission.isSelected == 1)
        .map(permission => permission.permission);

        this.selectedUser.defaultAddressCode = this.selectedAddress == null ? null : this.selectedAddress.code

       UsersApi.saveUser(this.selectedUser).then(
        (result)=> {
            if(result){
                this.cancelUserEdit()
                this.hideForm()
                this.getUserInfo(this.selectedUser.customerId)          
            }

        }
      ) 
    },

    showHidePassword(){
        this.passwordHidden=!this.passwordHidden
    },
    changePassword(user){
        this.showPWModal =true;
        this.isPasswordChange = true
        this.hideForm()
        this.selectedUser.id=user.id
        this.selectedUser.name=user.name
        this.selectedUser.userName=user.userName
    },
    cancelPasswordChangeEdit(){
        this.isPasswordChange= false
        this.cancelUserEdit()
        this.newPassword=null
        this.hideForm()
        this.showPWModal=false
    },

    updatePassword(){
        this.selectedUser.supplierId= this.selected ? this.selected.id : null
        UsersApi.adminUpdatePassword(this.selectedUser.id,this.newPassword).then(
        ()=> {
            this.getUserInfo(this.selectedUser.supplierId)          
            this.cancelPasswordChangeEdit()
        }
      )
    },

    getPermission(permission) {
        const foundElement = this.permissionGroupes.find(element => element.permission === permission);
        return foundElement || null;
    }
},



};
</script>
<style>

    .style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

</style>
<template>

    <div class="row pt-4 ">    
      <div class="col-sm-12">
        <div class="">
          <div class="">
            <div class="row pb-4">
                <div class="col-lg-10 col-md-9 col-sm-12">
                    <h3 class="card-title font-size-22 mb-4" style="font-size:22px;">{{$t('subscription.table.users')}} <strong>{{this.selectedUser.customerName}}</strong> </h3>
                    </div>
                        <div class="col-lg-2 col-md-3 col-sm-12 text-right">
                            <b-button variant="success" @click="addNew()"  class="float-right mb-4">
                                <i class="fas fa-plus text-white font-size-16 m-0 p-0 font-weight-bold align-middle mr-2"></i> 
                                <span class=" font-weight-bold text-white text-uppercase">{{$t('subscription.userModal.addNew')}} </span>
                            </b-button>
                        </div>      
                </div>

                <div class="table-responsive"  >
            <table class="table table-centered " >
            <thead class="thead-light">
                <tr>
                    <th></th>
                    
                
                <th class="text-left">{{$t('subscription.userModal.table.name')}}</th>
                <th class="text-left">{{$t('subscription.userModal.table.userName')}}</th>
                <th class="text-left">Admin</th>
                <th class="text-left" v-if="isGenerateApiKeyEnabled"></th>
                <th class="text-left">{{$t('subscription.userModal.table.status')}}</th>
              
                <th></th>
                <th></th>
                </tr>
            </thead>
            <tbody v-for="user in selectedUserList" :key="user.id">
                    <tr v-if="user.id!=null" >
                        <td></td>
                    <td>{{user.name}}</td>
                    <td>{{user.userName}}</td>
                    <td class="text-center"><i class="text-center" :class="user.permission.includes('CUST_ADMIN')  ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger'"></i></td>
                    <td><i :class="user.status===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i></td>
                        
                    <td>
                        <b-button @click="changePassword(user)  "   size="sm" variant="outline-dark"  >
                            <i class="fas fa-key font-size-16 align-middle mr-2"></i>{{$t('subscription.userModal.table.chnagePassword')}}
                        </b-button>
                    </td>

                    
                    <td v-if="isGenerateApiKeyEnabled">
                        <div class="key-button" @click="openGenerateToken(user)">
                            <img src="@/assets/images/key.svg" height="20"  />
                            <span>Générer Clé API</span>
                        </div>
                    </td>
                    

                    <td>
                        <a  :title="$t('subscription.userModal.table.edit')" href="javascript:void(0);"  @click="editUser(user)  " class="action-icon text-warning pr-2" >
                            <i class="fas fa-pencil-alt font-size-16"  />
                        </a>

                    </td>
                 </tr>

            </tbody>
            </table>
            <span v-if="selectedUserList[0] && selectedUserList[0].id==null" class="d-flex justify-content-center m-4 text-danger" > {{$t('subscription.userModal.table.empty')}} </span>

            </div> 
            
          </div>
        </div>
      </div>
                <b-modal
                        v-if="(showUsersModal && selected)  "
                        v-model="showUsersModal"
                        :title="isNew ? '' : $t('subscription.userModal.title') + selectedUser.name"
                        hide-footer 
                        centered 
                        title-class="text-primary"
                        title-tag="h5"
                        header-close-variant="danger"
                        size="lg" 
                        @change="handler(selectedUser.permission)">
                                  <b-button 
                                    variant="link"
                                    class=" p-0 m-0 pb-3  text-info font-weight-bold font-size-14 float-right" 
                                    @click="addNew()"
                                    >
                                    <i class="fas fa-edit " ></i>
                                    <span class="ml-2 ">{{$t('subscription.userModal.addNew')}} </span>
                                 </b-button>

                                 
                                 <div v-if="showForm" class="conatiner">
                                    <div v-if="showForm" class="row mt-4 pb-2" style="width:100%">
                                        <div class="form-group col-md-12 col-lg-3 pr-4 ">
                                            <label >{{$t('subscription.userModal.form.name')}}</label>
                                            <input
                                            type="text"
                                            class="form-control"
                                            v-model="selectedUser.name"
                                            />
                                    </div>
                                    <div class="form-group col-md-12 col-lg-5 pr-4">
                                        <label >{{$t('subscription.userModal.form.userName')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        v-model="selectedUser.userName"

                                        />
                                    </div>
                                    <div v-if="isNew" class="form-group col-md-12 col-lg-4 pr-4 ">
                                        <label >{{$t('subscription.userModal.form.password')}}</label>
                                        <form>
                                            <div class="input-group ">
                                                <input class="form-control" :type="passwordHidden ? 'password':'text'"  v-model="selectedUser.password" @keydown.enter.prevent >
                                                <div class="input-group-append">
                                                    <span class="input-group-text"><i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword()" ></i></span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div v-if="isMultiAddressSuported" class="form-group col-md-12 col-lg-5 pr-4">
                                        <label >{{$t('subscription.userModal.form.defaultAddress')}}</label>
                                        <v-select class="pb-2 font-size-16 custom-placeholder"   :options="optionsDeliveryAddresses" v-model="selectedAddress" placeholder="Adresse de livraison" label="address" >
                                            <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                                        </v-select>  
                                    </div>
                        
                                    </div>
                                    <div class="row mt-2 mb-4">
                                        <div class="col-12 ">
                                            <div class="float-left">
                                                <div  class="form-group  ">
                                                    <b-form-checkbox
                                                        value="1"
                                                        unchecked-value="0"
                                                        class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                                        v-model="selectedUser.status">   
                                                        <span class="font-size-14" :class="selectedUser.status == 1 ? 'text-info' : 'text-muted'">{{selectedUser.status == 1 ? $t('subscription.userModal.status.active') : $t('subscription.userModal.status.disabled')}}</span>
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                        </div>   

                                        <div class="col-12 mt-2">
                                            <div class="float-left">
                                                <div  class="form-group  ">

                                                    <b-form-checkbox
                                                        value="1"
                                                        unchecked-value="0"
                                                        class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-1 mt-0"
                                                        v-model="orderStatePermission.isSelected"
                                                    >   
                                                        <span class="font-size-14" :class="orderStatePermission.isSelected == 1 ? 'text-info' : 'text-muted'" >{{ orderStatePermission.label }}</span>
                                                        
                                                    </b-form-checkbox>
                                                    <span v-if="orderStatePermission.isSelected == 1" class=" text-danger"> <i class="fas fa-exclamation-triangle mr-1"></i> En activant cette option vous acceptez de recevoir des e-mails de notifications sur chaque modification de l'état de vos commandes.</span>

                                                </div>
                                            </div>
                                        </div>  

                                    </div>
                              
                                  <div  v-if="showForm" class="conatiner" >

                                             <fieldset class="row   border  p-4 " style="border-width: 2px !important ;" >
                                                <legend class=" font-size-16 text-primary px-2">Liste des Permissions</legend>

                                                <div class="float-left">
                                                            <div  class="col-12 mt-2 form-group  ">
                                                                <b-form-checkbox
                                                                    value="1"
                                                                    unchecked-value="0"
                                                                    class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                                                    v-model="adminPermission.isSelected "
                                                                    >
                                                                    <span class="font-size-14" :class="adminPermission.isSelected == 1  ? 'text-danger' : 'text-muted' ">Administrateur Client</span>
                                                                </b-form-checkbox>
                                                            </div>
                                                        </div>
                                                        <div class="conatiner mt-4" v-if="adminPermission.isSelected != 1 " >
                                                            <div class="row" >
                                                                <div class="col-lg-6  col-xs-12" v-for="permissionGroup in adminPermissionGroupes" :key="permissionGroup.id">
                                                                    <div class="float-left ">
                                                                            <div class="form-group">
                                                                                <b-form-checkbox
                                                                                    value="1"
                                                                                    unchecked-value="0"
                                                                                    class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                                                                    v-model="permissionGroup.isSelected"
                                                                                >   
                                                                                    <span class="font-size-14" :class="permissionGroup.isSelected == 1 ? 'text-info' : 'text-muted'" >{{ permissionGroup.label }}</span>
                                                                                    
                                                                                </b-form-checkbox>
                                                                            </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                        
                                            </fieldset>
                                        </div>

                                  <div v-if="showForm && isFtpPermissionVisible" class="conatiner mt-4">
                                             <fieldset class="row border p-4" style="border-width: 2px !important ;">
                                                <legend class="font-size-16 text-primary px-2">Liste FTP Permission</legend>
                                                  <div class="row w-100">
                                                        <div class="col-lg-6 col-xs-12" v-for="permissionGroup in ftpPermissionGroupes" :key="permissionGroup.id">
                                                            <div class="float-left">
                                                                <div class="form-group">
                                                                    <b-form-checkbox
                                                                        value="1"
                                                                        unchecked-value="0"
                                                                        class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                                                        v-model="permissionGroup.isSelected"
                                                                    >
                                                                        <span class="font-size-14" :class="permissionGroup.isSelected == 1 ? 'text-info' : 'text-muted'">{{ permissionGroup.label }}</span>
                                                                    </b-form-checkbox>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </fieldset>
                                        </div>

                                <div v-if="showForm" class="row mt-4" style="width:100%">

                                    <div class="col-lg-6  col-md-5 col-sm-5 " />

                                    <div class="col-lg-3 col-md-3 col-sm-3 pr-3 pb-1 " >
                                            
                                        <b-button variant="secondary" @click="cancelUserEdit();hideForm();" class="mr-2 w-100" >
                                            <i class="fas fa-times font-size-14 align-middle  mr-2" ></i> Annuler
                                        </b-button>
                                    </div>

                                    <div class="col-lg-3 col-md-4 col-sm-4 w-100 pr-sm-0 pr-3 pb-1 " >
                                        <b-button variant="success" @click="saveUser()" class="w-100 font-weight-bold" >
                                            <i class="fas fa-save font-size-14 align-middle mr-2 " ></i> Enregistrer
                                        </b-button>
                                    </div>
                                </div> 
                                
                            </div>
                    
       
          </b-modal>

<!--  change password -->

    <b-modal
                v-if="showPWModal"
                v-model="showPWModal"
                :title="$t('subscription.userModal.title') +selectedUser.name "
                hide-footer 
                centered 
                title-class="text-primary"
                title-tag="h5"
                header-close-variant="danger"
                size="lg"
        > 
        <div v-if="isPasswordChange" style="width:100%">
            <div class="form-group row mb-3 pt-2 ">
            <div class="col-md-6 col-form-label" for="pwd">{{$t('subscription.userModal.passwordNew')}} {{selectedUser.name}}</div>
               
            <div class="col-md-4">
                    <form autocomplete="off">
                        <div class="input-group ">
                            <input class="form-control" :type="passwordHidden ? 'password':'text'" autocomplete="new-password" v-model="newPassword" >
                            <div class="input-group-append">
                                <span class="input-group-text"><i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword()" ></i></span>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-md-2" >
                    <b-button variant="secondary" @click="cancelPasswordChangeEdit();hideForm()" class="mr-2 ml-2" >
                        <i class="fas fa-times font-size-14 align-middle  " ></i>
                    </b-button>
                    <b-button variant="success" @click="updatePassword();hideForm()" >
                        <i class="fas fa-save font-size-14 align-middle  " ></i>
                    </b-button>
                </div>
            </div>
        </div>
         
    </b-modal>
    <!--  change password -->









    <!-- Generate Token Modal -->
    <b-modal
        v-model="showTokenModal"
        hide-footer
        hide-header
        centered
        size="md"
        no-close-on-backdrop
        no-close-on-esc
    >
        <div class="token-modal-container p-4">
            <!-- Minimalist Pro-Danger Warning -->
            <div class="min-danger-alert">
                <i class="fas fa-exclamation-circle danger-icon"></i>
                <span class="danger-text">
                    <strong>Attention :</strong> Ce token est unique et ne sera affiché qu'<strong>une seule fois</strong>. 
                    Veuillez le copier immédiatement. Toute nouvelle génération 
                    <strong class="text-danger">annulera instantanément le token précédent</strong>.
                </span>
            </div>

            <!-- PHASE 1: Generation Prompt -->
            <div v-if="!generatedToken" class="token-step-wrapper animate__animated animate__fadeIn">
                <div class="security-illustration">
                    <div class="icon-circle">
                        <i class="fas fa-shield-alt"></i>
                    </div>
                </div>
                
                <h5 class="token-title">Accès Sécurisé</h5>
                <p class="token-subtitle">
                    Prêt à générer le jeton d'accès pour <br>
                    <span class="user-name-highlight">{{ selectedUser.name }}</span> ?
                </p>
                
                <b-button 
                    variant="primary" 
                    size="lg" 
                    @click="generateToken()" 
                    class="btn-generate-fancy"
                >
                    <span class="text-uppercase">Générer le Token</span>
                    <i class="fas fa-arrow-right ml-2"></i>
                </b-button>
            </div>

            <!-- PHASE 2: Token Display -->
            <div v-else class="token-step-wrapper animate__animated animate__fadeIn">
                <div class="success-illustration">
                    <div class="icon-circle success">
                        <i class="fas fa-check"></i>
                    </div>
                </div>
                
                <h5 class="token-title text-success">Token Généré</h5>
                <p class="token-subtitle">Veuillez copier et sauvegarder ce code en lieu sûr.</p>
                
                <div class="token-display-card">
                    <div class="token-value">{{ generatedToken }}</div>
                    <b-button 
                        :variant="isCopied ? 'success' : 'primary'" 
                        @click="copyToken()"
                        class="btn-copy-fancy transition-all"
                    >
                        <i :class="isCopied ? 'fas fa-check' : 'fas fa-copy'"></i> 
                        <span class="ml-2">{{ isCopied ? 'Copié !' : 'Copier' }}</span>
                    </b-button>
                </div>
            </div>

            <!-- Simple Footer -->
            <div class="token-footer">
                <b-button variant="link" class="text-muted font-size-13" @click="showTokenModal = false">
                    Annuler et fermer
                </b-button>
            </div>
        </div>
    </b-modal>


    
    </div>


</template>


<style scoped>

::v-deep .custom-placeholder .vs__search::placeholder {
  color: #495057;
  opacity: 1;
}
</style>


<style scoped>
.key-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 6px;
    background-color: #f3f3f4;
    color: #1f1f2e;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    border: 1px solid #d1d1d9;
}

.key-button:hover {
    background-color: #1f1f2e;
    color: #fff;
    border-color: #1f1f2e;
    box-shadow: 0 2px 8px rgba(31, 31, 46, 0.3);
}

.key-button:hover img {
    filter: brightness(0) invert(1);
}

.key-button span {
    font-size: 13px;
}

@media (max-width: 768px) {
    .key-button {
        padding: 6px;
        border-radius: 6px;
    }

    .key-button span {
        display: none;
    }
}

/* Container & General */
.token-modal-container {
    text-align: center;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* Minimalist Danger Alert */
.min-danger-alert {
    display: flex;
    align-items: center;
    background: #fffafa;
    border-left: 3px solid #dc3545;
    padding: 12px 16px;
    border-radius: 0px 6px 6px 0px;
    margin-bottom: 30px;
    text-align: left;
}
.danger-icon { color: #dc3545; font-size: 20px; margin-right: 12px; }
.danger-text { font-size: 15px; color: #5f6368; line-height: 1.5; }
.danger-text strong { color: #202124; font-weight: 600; }

/* Illustrations & Icons */
.security-illustration, .success-illustration {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
}
.icon-circle {
    width: 64px;
    height: 64px;
    background: #eef2ff;
    color: #4f46e5;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    box-shadow: 0 8px 20px rgba(79, 70, 229, 0.15);
}
.icon-circle.success {
    background: #ecfdf5;
    color: #10b981;
    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.15);
}

/* Typography */
.token-title {
    font-weight: 700;
    font-size: 20px;
    color: #1f2937;
    margin-bottom: 8px;
}
.token-subtitle {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 25px;
    line-height: 1.6;
}
.user-name-highlight {
    color: #111827;
    font-weight: 600;
    border-bottom: 2px solid #eef2ff;
}

/* Buttons */
.btn-generate-fancy {
    padding: 12px 30px !important;
    border-radius: 10px !important;
    font-weight: 600 !important;
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2) !important;
    transition: all 0.3s ease !important;
}
.btn-generate-fancy:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(0, 123, 255, 0.3) !important;
}

/* The Token Display Card */
.token-display-card {
    background: #f8fafc;
    border: 2px dashed #cbd5e1;
    border-radius: 16px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    transition: all 0.3s ease;
}
.token-value {
    font-family: 'Courier New', Courier, monospace;
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    letter-spacing: 2px;
    word-break: break-all;
}
.btn-copy-fancy {
    border-radius: 8px !important;
    padding: 8px 20px !important;
    font-weight: 500 !important;
}

.token-footer {
    margin-top: 30px;
}

.transition-all {
    transition: all 0.3s ease !important;
}
</style>